import Lang from './lang';

const csCZ: Lang = {
  PAGE_TITLE: 'PPL Widget administrace | Správa API klíčů',

  // Header
  MENU: 'Menu',
  MENU_LINK1: 'Osoby',
  MENU_LINK2: 'Firmy',
  MENU_LINK3: 'O nás',
  MENU_LINK4: 'Vyhledat zásilku',
  MENU_LINK5: 'Chci poslat balík',
  MENU_LINK6: 'Kariéra',
  MENU_LINK7: 'Zákaznický servis',

  // Footer
  FOOTER_NAME1: 'PPL',
  FOOTER_LINK11: 'O nás',
  FOOTER_LINK12: 'Mapa výdejních míst',
  FOOTER_LINK13: 'Seznam výdejních míst',
  FOOTER_LINK14: 'Přepravní síť PPL',
  FOOTER_LINK15: 'Aktuální informace',
  FOOTER_LINK16: 'Pro média',
  FOOTER_LINK17: 'Osobní údaje',
  FOOTER_LINK18: 'Kariéra',
  FOOTER_LINK19: 'Whistleblowing',
  FOOTER_NAME2: 'Osoby',
  FOOTER_LINK21: 'Vyhledat zásilku',
  FOOTER_LINK22: 'Výdejní místa',
  FOOTER_LINK23: 'Poslat zásilku',
  FOOTER_LINK24: 'Vrátit zboží',
  FOOTER_LINK25: 'Poškozená zásilka',
  FOOTER_LINK26: 'Zákaznický servis',
  FOOTER_LINK27: 'Mobilní aplikace',
  FOOTER_LINK28: 'Ke stažení pro osoby',
  FOOTER_NAME3: 'Firmy',
  FOOTER_LINK31: 'Stát se zákazníkem',
  FOOTER_LINK32: 'Poslat zásilku',
  FOOTER_LINK33: 'Vnitrostátní přeprava',
  FOOTER_LINK34: 'Mezinárodní přeprava',
  FOOTER_LINK35: 'Aplikace Klient',
  FOOTER_LINK36: 'Zákaznická zóna',
  FOOTER_LINK37: 'Integrátoři',
  FOOTER_LINK38: 'Ke stažení - firmy',
  FOOTER_NAME4: 'Užitečné odkazy',
  FOOTER_LINK41: 'Nastavení souhlasu',
  FOOTER_LINK42: 'Zákaznický servis',
  FOOTER_LINK43: 'Kontaktní formulář',
  FOOTER_LINK44: 'Poškozená zásilka',
  FOOTER_LINK45: 'Parcelshopy',
  FOOTER_LINK46: 'Chci mít Parcelbox',
  FOOTER_LINK47: 'Chci mít Parcelshop',
  FOOTER_LINK48: 'Provozuji Parcelshop',
  FOOTER_LINK49: 'Řešení sporů',
  FOOTER_LINK4X: 'Obchodní podmínky',
  FOOTER_NAME5: 'Sledujte nás',
  FOOTER_NAME6: 'Mobilní aplikace MOJEPPL',
  FOOTER_NAME7: 'náš svět jsou vaše zásilky',

  // Landing page
  LANDING_SUBTITLE:
    'Nastavte widget výdejních míst a snadno jej vložte na web, nebo upravte nastavení již nasazeného řešení.',
  API_ENDPOINT_LABEL: 'API Endpoint:',
  CREATE_API_KEY: 'Získat přístup',
  EDIT_API_KEY: 'Upravit nastavení',

  // CreateApiKeyForm
  CREATE_API_KEY_TITLE: 'Nastavení přístupu ke konfiguraci widgetu',
  CREATE_API_KEY_SUBTITLE:
    'Zadejte své zákaznické údaje. Přístup ke konfiguraci vám pošleme e-mailem.',
  ORG_ID_LABEL: 'IČO',
  ORG_ID_PLACEHOLDER: 'Zadejte IČ',
  CUSTOMER_ID_LABEL: 'ID zákazníka',
  CUSTOMER_ID_PLACEHOLDER: 'Zadejte ID zákazníka',
  EMAIL_LABEL: 'E-mail',
  EMAIL_PLACEHOLDER: 'vas.email@example.com',
  EMAIL_TOOLTIP:
    'Kontaktní e-mail se musí shodovat s e-mailem uvedeným ve smlouvě.',
  CUSTOMER_ID_TOOLTIP:
    'Informaci o ID zákazníka naleznete ve své klientské zóně.',
  SUBMIT: 'Vygenerovat API klíč',
  SUBMITTING: 'Odesílám...',
  CANCEL: 'Zrušit',
  CLOSE: 'Zavřít',
  SUCCESS_REQUEST_SENT: 'Hotovo! Přístup je na cestě',
  SUCCESS_API_KEY_SENT:
    'Odkaz pro konfiguraci widgetu jsme vám poslali e-mailem.',
  RESEND_EMAIL: 'Znovu odeslat e-mail',
  ERR_ORG_ID_REQUIRED: 'Vyplňte prosím IČ',
  ERR_EMAIL_REQUIRED: 'Vyplňte prosím e-mail',
  ERR_ORG_ID_INVALID: 'IČ musí obsahovat pouze čísla (max 20 znaků)',
  ERR_CUSTOMER_ID_INVALID: 'ID zákazníka musí být kladné číslo',
  ERR_EMAIL_INVALID: 'Zadejte platnou e-mailovou adresu',
  ERR_CUST_ID_OR_EMAIL_REQUIRED:
    'Vyplňte prosím ID zákazníka nebo kontaktní e-mail',
  ERR_CUST_ID_OR_EMAIL_INVALID:
    'Zadejte platné číslo zákazníka nebo e-mailovou adresu',
  ERR_RECAPTCHA: 'Nepodařilo se ověřit reCAPTCHA. Zkuste to prosím znovu.',
  ERR_ORG_CUSTOMER_MISMATCH:
    'Cust ID je neplatné. Kontaktujte prosím Zákaznický servis.',
  ERR_ORG_EMAIL_MISMATCH:
    'Váš e-mail jsme nenalezli, zadejte prosím své ID nebo kontaktujte zákaznický servis.',
  ERR_REQUEST_FAILED:
    'Nepodařilo se odeslat požadavek. Zkuste to prosím znovu.',

  // EditApiKeyForm
  APP_TITLE: 'PPL Widget Administrace',
  EDIT_API_KEY_TITLE: 'Editace konfigurace',
  EDIT_API_KEY_DESC:
    'Nakonfigurujte si widget výdejních míst a vložte jej na svůj web během několika minut.',
  SEND_LINK: 'Upravit nastavení',
  SENDING: 'Odesílám...',
  LINK_SENT_TITLE: 'Odkaz byl odeslán!',
  LINK_SENT_DESC:
    'Na adresu {email} jsme odeslali e-mail s odkazem pro správu vašich API klíčů.',
  LINK_VALIDITY: 'Odkaz je platný 60 minut.',

  // ActivatePage
  ACTIVATING: 'Aktivuji váš odkaz...',
  ACTIVATION_COMPLETE: 'Aktivace dokončena',
  ACTIVATION_ERROR: 'Chyba při aktivaci',
  YOUR_API_KEYS: 'Vaše API klíče',
  API_KEY_DETAIL: 'Detail API klíče',
  API_KEY_ACTIVATED: 'API klíč byl úspěšně aktivován!',
  GO_TO_SETTINGS: 'Přejít do nastavení',
  CAN_CONFIGURE_DOMAINS:
    'Nyní můžete přejít do nastavení a konfigurovat povolené domény.',
  NO_API_KEYS: 'Nebyly nalezeny žádné API klíče pro tento e-mail.',
  CUSTOMER_ID: 'Customer ID:',
  API_KEY: 'API klíč',
  COPY_API_KEY: 'Kopírovat API klíč',
  CREATED: 'Vytvořeno:',
  LOGOUT: 'Odhlásit se',
  SESSION_EXPIRES_IN_TOOLTIP: 'Zbývající čas relace',
  SESSION_EXPIRED: 'Vaše relace vypršela. Přihlaste se prosím znovu.',
  BACK_TO_LIST: 'Zpět na seznam',
  LIST_APIKEY: 'Seznam konfigurací',
  SAVE_CHANGES: 'Uložit změny',
  SAVING: 'Ukládám...',
  CHANGES_SAVED:
    'Změny byly úspěšně uloženy a widget byl aktivován. Vaše změny se projeví za několik minut.',
  BACK: 'Zpět',

  // ActivatePage - errors
  ERR_TOKEN_ALREADY_USED:
    'Tento aktivační odkaz byl již použit. Požádejte o nový.',
  ERR_TOKEN_EXPIRED: 'Platnost aktivačního odkazu vypršela. Požádejte o nový.',
  ERR_INVALID_LINK: 'Neplatný aktivační odkaz.',
  ERR_SESSION_EXPIRED:
    'Vaše relace vypršela. Požádejte o nový aktivační odkaz.',
  SESSION_EXPIRED_TITLE: 'Vaše relace vypršela',
  SESSION_EXPIRED_DESC:
    'Nedokončili jste práci? Na email vám pošleme nový přístup.',
  SESSION_EXPIRED_BUTTON: 'Poslat přístup',
  ERR_LOAD_API_KEY: 'Nepodařilo se načíst detail API klíče.',
  ERR_SAVE_FAILED: 'Nepodařilo se uložit změny. Zkuste to prosím znovu.',
  ERR_SELECT_COUNTRY: 'Musíte vybrat alespoň jednu zemi.',
  ERR_SELECT_AP_TYPE: 'Musíte vybrat alespoň jeden typ výdejního místa.',
  ERR_DOMAINS_EMPTY: 'Všechny domény musí mít vyplněnou hodnotu.',
  ERR_REQUIRED_FIELD: 'Povinné pole',
  ERR_DOMAIN_INVALID: 'Neplatný formát domény (např. example.com)',
  SESSION_TIMEOUT_WARNING:
    'Konfiguraci je nutné dokončit do 60 minut. Poté dojde k jejímu přerušení.',

  // ActivatePage - claims editor
  ALLOWED_DOMAINS: 'Povolené domény',
  ADD_DOMAIN: 'Přidat doménu',
  NO_DOMAIN_RESTRICTION:
    'Žádné omezení domén. Widget bude fungovat na všech doménách.',
  DOMAIN_PLACEHOLDER: 'např. example.com',
  REMOVE_DOMAIN: 'Odstranit doménu',
  ACCESS_POINT_TYPES: 'Typy přístupových bodů',
  DEFAULT_LANGUAGE: 'Výchozí jazyk',
  LANG_CS: 'Čeština',
  LANG_EN: 'Angličtina',
  LANG_PL: 'Polština',
  COUNTRIES: 'Země',
  COUNTRIES_HINT: '(alespoň jedna)',

  // Widget Wizard
  WIDGET_SETTINGS: 'Nastavení widgetu',
  HELP_TEXT: 'Potřebujete poradit? Podívejte se do',
  HELP_TEXT_MOBILE: 'Pomoc najdete v',
  HELP_LINK_TEXT: 'manuálu',
  ADD_DOMAIN_LABEL: 'Přidejte doménu',
  ADD_NEXT: 'přidat další',
  PRODUCT_TYPE: 'Typ produktu',
  PRODUCT_CUSTOM: 'Vlastní nastavení',
  PRODUCT_SMART2BOX: 'Smart 2 Box',
  PRODUCT_SMART2BOX_TOOLTIP:
    'Toto nastavení automaticky předvybere typ výdejního místa "PPL Parcelbox" a omezí výběr pouze na Českou republiku.',
  ACCESS_POINT_TYPES_LABEL: 'Typy výdejních míst',
  AP_PARCELSHOP: 'ParcelShop - Výdejní místa PPL',
  AP_PPLPARCELBOX: 'PPL ParcelBox - Samoobslužné boxy PPL',
  AP_ALZABOX: 'AlzaBox - Samoobslužné boxy Alza',
  AVAILABLE_COUNTRIES: 'Dostupné země',
  SELECT_ALL: 'Vybrat vše',
  SELECTED_COUNT: 'Vybrané',
  DEFAULT_WIDGET_COUNTRY: 'Výchozí země widgetu',
  RESET: 'Reset',
  PUBLISH: 'Aktivovat',
  WIDGET_CODE: 'Kód widgetu',
  COPY_CODE: 'Kopírovat',
  CODE_COPIED: 'Kód byl zkopírován do schránky.',
  API_KEY_COPIED: 'API klíč byl zkopírován do schránky.',
  WIDGET_CODE_COMMENT_SCRIPT:
    'Vložte tento script do sekce <head> vaší stránky',
  WIDGET_CODE_COMMENT_ELEMENT:
    'Vložte tento element na místo, kde chcete zobrazit widget',
  WIDGET_CODE_COMMENT_BUTTON_ONCLICK:
    'Varianta 1: Otevření widgetu pomocí onclick',
  WIDGET_CODE_COMMENT_BUTTON_EVENT:
    'Varianta 2: Otevření widgetu pomocí event listeneru',
  WIDGET_CODE_BUTTON_TEXT: 'Vybrat výdejní místo',
  PREVIEW: 'Náhled',
  WIDGET_CODE_TAB_TOOLTIP:
    'Nejprve potvrďte zvolenou konfiguraci nastavení, poté ji aktivujte tlačítkem Aktivovat.',
  VIEW_MODE_LABEL: 'Typ zobrazení',
  VIEW_MODE_INLINE: 'Vložený do stránky (Inline)',
  VIEW_MODE_MODAL: 'Vyskakovací okno (Modal)',
  ACTIVATION_SNACKBAR:
    'Pokud kód implementujete poprvé, zkopírujte jej a vložte do integrace. Při dalších úpravách stačí kliknout na \u201AAktivovat\u2018 – změny se propíší automaticky do kódu.',

  // API Key List
  SELECT_CONFIG_TITLE: 'Vyberte konfiguraci k úpravě',
  SELECT_CONFIG_DESC: 'Zvolte API klíč/doménu, kterou chcete upravit.',
  DOMAINS_LABEL: 'Domény',
  EDIT_BUTTON: 'Upravit',
  KEY_ACTIVE: 'Aktivní',
  KEY_INACTIVE: 'Neaktivní',

  // Unsaved changes dialog
  UNSAVED_CHANGES_TITLE: 'Máte neuložené změny',
  UNSAVED_CHANGES_DESC: 'Chcete uložit změny před odchodem?',
  DISCARD: 'Neukládat',
};

export default csCZ;
